/* eslint-disable brace-style */
/* eslint-disable no-tabs */

import http from "../../constants/token-interceptor";
import {
  resetPasswordURL,
  logOutURL,
  logInURL,
  signUpURL,
  forgotPasswordURL,
  changePasswordURL,
  getUserProfileURL,
  emulateUserLogInURL,
  emulateUserAuthorizationURL,
  getTargetLocationURL,
  getSecurityQuestionsURL,
  getFetchUser,
  updateUserProfile,
  setSecurityQuestionsURL,
  deleteResetSecurity,
  getResetSecurityURL,
  setVerifyAccount,
} from "../../constants/microservices-helper";
import ERRORS_CONST from "../../constants/errors";
import GLOBAL_CONST from "../../constants/global";
import { getAppMode } from "../../helpers/getAppModeHelpers";
// constants
const LOG_IN_START = "sponsorship/authentication/LOG_IN_START";
const LOG_IN_SUCCESS = "sponsorship/authentication/LOG_IN_SUCCESS";
const LOG_IN_FAILURE = "sponsorship/authentication/LOG_IN_FAILURE";

const VERIFY_ACCOUNT_START = "sponsorship/authentication/VERIFY_ACCOUNT_START";
const VERIFY_ACCOUNT_SUCCESS =
  "sponsorship/authentication/VERIFY_ACCOUNT_SUCCESS";
const VERIFY_ACCOUNT_FAILURE =
  "sponsorship/authentication/VERIFY_ACCOUNT_FAILURE";
const LOG_OUT_START = "sponsorship/authentication/LOG_OUT_START";
const LOG_OUT_SUCCESS = "sponsorship/authentication/LOG_OUT_SUCCESS";
const LOG_OUT_FAILURE = "sponsorship/authentication/LOG_OUT_FAILURE";
const SIGN_UP_START = "sponsorship/authentication/SIGN_UP_START";
const SIGN_UP_SUCCESS = "sponsorship/authentication/SIGN_UP_SUCCESS";
const SIGN_UP_FAILURE = "sponsorship/authentication/SIGN_UP_FAILURE";
const FETCH_USER_PROFILE_START =
  "sponsorship/authentication/FETCH_USER_PROFILE_START";
const FETCH_USER_PROFILE_SUCCESS =
  "sponsorship/authentication/FETCH_USER_PROFILE_SUCCESS";
const FETCH_USER_PROFILE_FAILURE =
  "sponsorship/authentication/FETCH_USER_PROFILE_FAILURE";

const FORGOT_PASSWORD_START =
  "sponsorship/authentication/FORGOT_PASSWORD_START";
const FORGOT_PASSWORD_SUCCESS =
  "sponsorship/authentication/FORGOT_PASSWORD_SUCCESS";
const FORGOT_PASSWORD_FAILURE =
  "sponsorship/authentication/FORGOT_PASSWORD_FAILURE";

const CHANGE_PASSWORD_START =
  "sponsorship/authentication/CHANGE_PASSWORD_START";
const CHANGE_PASSWORD_SUCCESS =
  "sponsorship/authentication/CHANGE_PASSWORD_SUCCESS";
const CHANGE_PASSWORD_FAILURE =
  "sponsorship/authentication/CHANGE_PASSWORD_FAILURE";

const RESET_PASSWORD_START = "sponsorship/authentication/RESET_PASSWORD_START";
const RESET_PASSWORD_SUCCESS =
  "sponsorship/authentication/RESET_PASSWORD_SUCCESS";
const RESET_PASSWORD_FAILURE =
  "sponsorship/authentication/RESET_PASSWORD_FAILURE";

const PRE_RESET_PASSWORD_START =
  "sponsorship/authentication/PRE_RESET_PASSWORD_START";
const PRE_RESET_PASSWORD_SUCCESS =
  "sponsorship/authentication/PRE_RESET_PASSWORD_SUCCESS";
const PRE_RESET_PASSWORD_FAILURE =
  "sponsorship/authentication/PRE_RESET_PASSWORD_FAILURE";

const CLEAR_ERRORS = "sponsorship/authentication/CLEAR_ERRORS";

const USER_PROFILE_START = "sponsorship/authentication/USER_PROFILE_START";
const USER_PROFILE_SUCCESS = "sponsorship/authentication/USER_PROFILE_SUCCESS";
const USER_PROFILE_FAILURE = "sponsorship/authentication/USER_PROFILE_FAILURE";

const EMULATE_USER_START = "sponsorship/authentication/EMULATE_USER_START";
const EMULATE_USER_SUCCESS = "sponsorship/authentication/EMULATE_USER_SUCCESS";
const EMULATE_USER_FAILURE = "sponsorship/authentication/EMULATE_USER_FAILURE";

const AUTHORIZED_EMULATE_USER_START =
  "sponsorship/authentication/AUTHORIZED__USER_START";
const AUTHORIZED_EMULATE_USER_SUCCESS =
  "sponsorship/authentication/AUTHORIZED__USER_SUCCESS";
const AUTHORIZED_EMULATE_USER_FAILURE =
  "sponsorship/authentication/AUTHORIZED__USER_FAILURE";
const SET_SECURITY_QUESTIONS_START =
  "sponsorship/authentication/SET_SECURITY_QUESTIONS_START";
const SET_SECURITY_QUESTIONS_SUCCESS =
  "sponsorship/authentication/SET_SECURITY_QUESTIONS_SUCCESS";
const SET_SECURITY_QUESTIONS_FAILURE =
  "sponsorship/authentication/SET_SECURITY_QUESTIONS_FAILURE";
const UPDATE_PROFILE_START = "sponsorship/authentication/UPDATE_PROFILE_START";
const UPDATE_PROFILE_SUCCESS =
  "sponsorship/authentication/UPDATE_PROFILE_SUCCESS";
const UPDATE_PROFILE_FAILURE =
  "sponsorship/authentication/SET_SECURITY_QUESTIONS_FAILURE";

const UPDATE_USER_PROFILE_START =
  "sponsorship/authentication/UPDATE_USER_PROFILE_START";
const UPDATE_USER_PROFILE_SUCCESS =
  "sponsorship/authentication/UPDATE_USER_PROFILE_SUCCESS";
const UPDATE_USER_PROFILE_FAILURE =
  "sponsorship/authentication/UPDATE_USER_PROFILE_FAILURE";
const CLEAR_UPDATE_USER_PROFILE_FAILURE =
  "sponsorship/authentication/CLEAR_UPDATE_USER_PROFILE_FAILURE";
export const FETCH_TARGETLOCATION_START =
  "sponsorship/proposals/FETCH_TARGETLOCATION_START";
export const FETCH_TARGETLOCATION_SUCCESS =
  "sponsorship/proposals/FETCH_TARGETLOCATION_SUCCESS";
export const FETCH_TARGETLOCATION_FAILURE =
  "sponsorship/proposals/FETCH_TARGETLOCATION_FAILURE";
export const FETCH_TARGETLOCATION_RESET =
  "sponsorship/proposals/FETCH_TARGETLOCATION_RESET";

export const FETCH_ALL_SECURITY_QUESTIONS_START =
  "sponsorship/proposals/FETCH_ALL_SECURITY_QUESTIONS_START";
export const FETCH_ALL_SECURITY_QUESTIONS_SUCCESS =
  "sponsorship/proposals/FETCH_ALL_SECURITY_QUESTIONS_SUCCESS";
export const FETCH_ALL_SECURITY_QUESTIONS_FAILURE =
  "sponsorship/proposals/FETCH_ALL_SECURITY_QUESTIONS_FAILURE";
const CLEAR_UPDATE_LOGIN_FAILURE_FAILURE =
  "sponsorship/authentication/CLEAR_UPDATE_LOGIN_FAILURE_FAILURE";

// initialState
const initialState = {
  userName: null,
  id: null,
  isAuthenticated: !!sessionStorage.getItem("access_token"),
  isFetching: false,
  hasSecurityQuestions: !!sessionStorage.getItem("hasSecurityQuestions"),
};

// reducer
export default function reducer(state = initialState, { type, payload }) {
  switch (type) {
    case LOG_IN_START:
    case LOG_IN_SUCCESS:
    case LOG_IN_FAILURE:
      const { userUnverified } = payload;
      return { ...state, ...payload, userUnverified };
    case CLEAR_UPDATE_LOGIN_FAILURE_FAILURE:
      return { ...state, ...payload, userUnverified: false };
    case FETCH_USER_PROFILE_START:
    case FETCH_USER_PROFILE_SUCCESS:
      return { ...state, ...payload };
    case FETCH_USER_PROFILE_FAILURE:
      return { ...state, ...payload };
    case LOG_OUT_START:
    case LOG_OUT_FAILURE:
      return { ...state, ...payload };
    case LOG_OUT_SUCCESS:
      return {
        userName: null,
        id: null,
        isAuthenticated: false,
        isFetching: false,
      };
    case SIGN_UP_START:
    case SIGN_UP_FAILURE:
      return { ...state, ...payload };
    case SIGN_UP_SUCCESS:
      const { isNewUser, isAccountVerified } = payload;
      return { ...state, isNewUser, isAccountVerified };
    case FORGOT_PASSWORD_START:
    case FORGOT_PASSWORD_SUCCESS:
    case FORGOT_PASSWORD_FAILURE:
      return { ...state, ...payload };
    case CHANGE_PASSWORD_START:
    case CHANGE_PASSWORD_SUCCESS:
    case CHANGE_PASSWORD_FAILURE:
      return { ...state, ...payload };
    case FETCH_TARGETLOCATION_START:
    case FETCH_TARGETLOCATION_SUCCESS:
    case FETCH_TARGETLOCATION_FAILURE:
    case FETCH_TARGETLOCATION_RESET:
      return { ...state, ...payload };
    case RESET_PASSWORD_START:
    case RESET_PASSWORD_SUCCESS:
    case RESET_PASSWORD_FAILURE:
      return { ...state, ...payload };
    case PRE_RESET_PASSWORD_START:
    case PRE_RESET_PASSWORD_SUCCESS:
    case PRE_RESET_PASSWORD_FAILURE:
      return { ...state, ...payload };
    case SET_SECURITY_QUESTIONS_SUCCESS:
    case SET_SECURITY_QUESTIONS_FAILURE:
    case UPDATE_PROFILE_START:
    case UPDATE_PROFILE_SUCCESS:
    case UPDATE_PROFILE_FAILURE:
      return { ...state, ...payload };
    case UPDATE_USER_PROFILE_START:
    case UPDATE_USER_PROFILE_SUCCESS:
    case UPDATE_USER_PROFILE_FAILURE:
      return { ...state, ...payload };
    case CLEAR_UPDATE_USER_PROFILE_FAILURE:
      return { ...state, ...payload };
    case CLEAR_ERRORS:
      const { error, ...rest } = state;
      return rest;
    case USER_PROFILE_START:
    case USER_PROFILE_FAILURE:
      return { ...state, ...payload };
    case USER_PROFILE_SUCCESS:
      const currentUserEmail = payload.userProfile.data.EmailAddress;
      const firstName = payload.userProfile?.data?.FirstName;
      const lastName = payload.userProfile?.data?.LastName;

      return { ...state, ...payload, currentUserEmail, firstName, lastName };
    case AUTHORIZED_EMULATE_USER_START:
    case AUTHORIZED_EMULATE_USER_FAILURE:
      return { ...state, ...payload };
    case EMULATE_USER_FAILURE:
      return { ...state, ...payload };
    case AUTHORIZED_EMULATE_USER_SUCCESS:
      const { clientKey, isEmulateAuthorized, isLoading } = payload;
      return { ...state, clientKey, isEmulateAuthorized, isLoading };
    case VERIFY_ACCOUNT_START:
      return {
        ...state,
        isVerifyAccountFetching: true,
        isVerified: false,
        userVerificationExpired: false,
        userVerificationError: false,
        error: null,
      };
    case VERIFY_ACCOUNT_SUCCESS:
      return {
        ...state,
        isVerifyAccountFetching: false,
        isVerified: true,
        userVerificationExpired: payload?.userVerificationExpired,
        data: payload.data,
        userVerificationError: false,
        error: null,
      };
    case VERIFY_ACCOUNT_FAILURE:
      return {
        ...state,
        isVerifyAccountFetching: false,
        isVerified: false,
        userVerificationExpired: payload?.userVerificationExpired,
        userVerificationError: payload?.userVerificationError,
        error: payload.error,
      };
    default:
      return state;
    case FETCH_ALL_SECURITY_QUESTIONS_START:
    case FETCH_ALL_SECURITY_QUESTIONS_SUCCESS:
      return { ...state, ...payload };
    case FETCH_ALL_SECURITY_QUESTIONS_FAILURE:
      return { ...state, ...payload };
  }
}

export const sessionLogOut = () => {
  return () => {
    const url = logOutURL();
    http
      .get(url)
      .then(() => {
        sessionStorage.clear();
      })
      .catch(() => {
        sessionStorage.clear();
      });
  };
};

export const logOut = (user) => {
  return (dispatch) => {
    dispatch({
      type: LOG_OUT_START,
      payload: {
        id: "somethingUnique",
        data: "bunches of it",
        isAuthenticated: false,
        isFetching: true,
      },
    });
    const url = logOutURL();
    http
      .get(url)
      .then((response) => {
        sessionStorage.clear();
        dispatch({
          type: LOG_OUT_SUCCESS,
          payload: {},
        });
      })
      .catch(() => {
        sessionStorage.clear();
        dispatch({
          type: LOG_OUT_SUCCESS,
          payload: {},
        });
      });
  };
};

export const setSecurityQuestions = (payload) => {
  return (dispatch) => {
    dispatch({
      type: SET_SECURITY_QUESTIONS_START,
      payload: {
        isFetching: true,
        isLoading: false,
      },
    });
    const url = setSecurityQuestionsURL();
    http
      .post(url, { SecurityQuestions: payload.SecurityQuestions })
      .then((response) => {
        sessionStorage.setItem("hasSecurityQuestions", true);

        dispatch({
          type: SET_SECURITY_QUESTIONS_SUCCESS,
          payload: {
            hasSecurityQuestions: true,
            isFetching: false,
            isLoading: false,
          },
        });
      })
      .catch((e) => {
        sessionStorage.setItem("hasSecurityQuestions", false);

        dispatch({
          type: SET_SECURITY_QUESTIONS_FAILURE,
          payload: {
            error: "You are not authorized to access this page",
            hasSecurityQuestions: false,
            isFetching: false,
            isLoading: true,
          },
        });
      });
  };
};

export const clearSecurityQuestions = (user) => {
  return (dispatch) => {
    dispatch({
      type: SET_SECURITY_QUESTIONS_START,
      payload: {
        isFetching: true,
        isLoading: true,
      },
    });
    const url = deleteResetSecurity();
    http
      .delete(url)
      .then(() => {
        sessionStorage.setItem("hasSecurityQuestions", false);

        dispatch({
          type: SET_SECURITY_QUESTIONS_SUCCESS,
          payload: {
            hasSecurityQuestions: false,
            isFetching: false,
            isLoading: false,
          },
        });
      })
      .catch(() => {
        sessionStorage.setItem("hasSecurityQuestions", true);
        dispatch({
          type: SET_SECURITY_QUESTIONS_FAILURE,
          payload: {
            error: "Failed to reset security questions",
            hasSecurityQuestions: true,
            isFetching: false,
            isLoading: false,
          },
        });
      });
  };
};

export const clearError = () => ({
  type: CLEAR_ERRORS,
  payload: {},
});

export const logIn = (user, query) => {
  const querystring = require("querystring");
  const requestBody = {
    UserName: user.email,
    Password: user.password,
    grant_type: "password",
  };

  sessionStorage.setItem("email", user.email);

  return (dispatch) => {
    dispatch({
      type: LOG_IN_START,
      payload: {
        isAuthenticated: false,
        isFetching: true,
        isButtonDisable: true,
        type: "Login",
        userUnverified: false,
      },
    });

    const url = logInURL();

    http
      .post(url, querystring.stringify(requestBody))
      .then((response) => {
        const data = response.data;
        if (data) {
          sessionStorage.setItem("access_token", data.access_token);
          sessionStorage.setItem(
            "hasSecurityQuestions",
            response?.headers?.["x-security-questions"]
              ?.trim()
              ?.toLowerCase() === "true"
          );

          if (query) {
            dispatch(targetLocation(query));
          } else {
            dispatch({
              type: LOG_IN_SUCCESS,
              payload: {
                isAuthenticated: true,
                isFetching: false,
                type: "Login",
                hasSecurityQuestions:
                  response?.headers?.["x-security-questions"]
                    ?.trim()
                    ?.toLowerCase() === "true",
              },
            });
          }
        }
      })
      .catch((error) => {
        if (
          error &&
          error.response &&
          error.response.status === 400 &&
          error.response.data &&
          error.response.data.error === 'Force_Password_Reset'
        ) {
          dispatch({
            type: LOG_IN_FAILURE,
            payload: {
              needPasswordChange: true,
              data: error,
              isAuthenticated: false,
              isFetching: false,
              type: 'Login',
              userUnverified: false
            }
          })
        } else if (error?.response?.headers['x-account-unverified']) {
          dispatch({
            type: LOG_IN_FAILURE,
            payload: {
              error:
                error?.response?.headers['x-account-unverified']?.trim()?.toLowerCase() === 'true' ? 
                'This account is unverified. Please check your email to complete account creation.': 
                'Your request cannot be processed. Please reach out to Tech Support.',
              data: error,
              isAuthenticated: false,
              isFetching: false,
              isButtonDisable: false,
              type: 'Login',
              userUnverified: error?.response?.headers['x-account-unverified']?.trim()?.toLowerCase() === 'true'
            }
          })
        } else {
          dispatch({
            type: LOG_IN_FAILURE,
            payload: {
              error:
                'Either the username or password entered was incorrect, or you have temporarily locked out your account. If you have continue to have trouble, please try again later or click Forgot Password if you have forgotten your password.',
              data: error,
              isAuthenticated: false,
              isFetching: false,
              isButtonDisable: false,
              type: 'Login',
              userUnverified: false
            }
          })
        }
      });
  };
};

// export const resetTargetLocation = () => ({
// 	type: FETCH_TARGETLOCATION_RESET,
// 	payload: {}
//   });

export const resetTargetLocation = () => (dispatch) => {
  dispatch({
    type: FETCH_TARGETLOCATION_RESET,
    payload: {
      targetLocationData: null,
      isFetching: false,
      // fetchSuccess: true,
      isLoading: false,
    },
  });
};

export const targetLocation = (query) => {
  return (dispatch) => {
    dispatch({
      type: FETCH_TARGETLOCATION_START,
      isFetching: true,
      isLoading: false,
    });
    const url = getTargetLocationURL();
    http
      .post(url, { payload: query })
      .then((response) => {
        dispatch({
          type: FETCH_TARGETLOCATION_SUCCESS,
          payload: {
            targetLocationData: response.data,
            isFetching: false,
            // fetchSuccess: true,
            isLoading: true,
          },
        });
        dispatch({
          type: LOG_IN_SUCCESS,
          payload: {
            isAuthenticated: true,
            hasSecurityQuestions: !!sessionStorage.getItem(
              "hasSecurityQuestions"
            ),

            // hasSecurityQuestions: response?.headers?.['x-security-questions'],
            isFetching: false,
            type: "Login",
          },
        });
      })
      .catch((error) => {
        if (error && error.response && error.response.data) {
          dispatch({
            type: FETCH_TARGETLOCATION_FAILURE,
            payload: {
              error: ERRORS_CONST.ERROR_TARGETLOCATION_PROPOSALS,
              ...error,
              targetLocationData: error.response.data,
              isFetching: false,
              isLoading: true,
            },
          });
          dispatch({
            type: LOG_IN_SUCCESS,
            payload: {
              isAuthenticated: true,
              hasSecurityQuestions: !!sessionStorage.getItem(
                "hasSecurityQuestions"
              ),

              isFetching: false,
              type: "Login",
            },
          });
        } else {
          dispatch({
            type: FETCH_TARGETLOCATION_FAILURE,
            payload: {
              error: ERRORS_CONST.ERROR_TARGETLOCATION_PROPOSALS,
              ...error,
              targetLocationData: "Could not find target locatin",
              isFetching: false,
              isLoading: true,
            },
          });
          dispatch({
            type: LOG_IN_SUCCESS,
            payload: {
              isAuthenticated: true,
              hasSecurityQuestions: !!sessionStorage.getItem(
                "hasSecurityQuestions"
              ),

              isFetching: false,
              type: "Login",
            },
          });
        }
      });
  };
};

export const signUp = (user, query) => {
  const mode = getAppMode();

  const requestBody = {
    EmailAddress: user.email,
    Password: user.password,
    FirstName: user["user-fname"],
    LastName: user["user-lname"],
    SecurityQuestions: user.SecurityQuestions,
    Source: mode,
  };

  return (dispatch) => {
    dispatch({
      type: SIGN_UP_START,
      payload: {
        isAuthenticated: false,
        isFetching: true,
        type: "Signup",
      },
    });
    const url = signUpURL();
    http
      .post(url, requestBody)
      .then((response) => {
        dispatch({
          type: SIGN_UP_SUCCESS,
          payload: {
            isNewUser: true,
            isFetching: false,
            isAccountVerified: true,
          },
          isFetching: false,
        });
        // if(query) {
        // 	dispatch(targetLocation(query))
        // }
        // dispatch(logIn(user, query))
      })
      .catch((error) => {
        if (
          error?.response?.status === 400 &&
          error?.response?.headers["x-account-exists"]
            ?.trim()
            ?.toLowerCase() === "true"
        ) {
          dispatch({
            type: SIGN_UP_FAILURE,
            payload: {
              ...error.response,
              error: GLOBAL_CONST.ERROR_MSG_ACCOUNT_EXISTS,
              isAuthenticated: false,
              isFetching: false,
              type: "Signup",
              isAccountVerified: false,
            },
          });
        } else if (
          error?.response?.status === 400 &&
          error?.response?.headers["x-account-unverified"]
            ?.trim()
            ?.toLowerCase()
        ) {
          dispatch({
            type: SIGN_UP_FAILURE,
            payload: {
              ...error.response,
              error:
                error?.response?.headers["x-account-unverified"]
                  ?.trim()
                  ?.toLowerCase() === "true"
                  ? "This account is unverified. Please check your email to complete account creation."
                  : "Your request cannot be processed. Please reach out to Tech Support.",
              isAuthenticated: false,
              isFetching: false,
              type: "Signup",
              isAccountVerified: false,
            },
          });
        } else if (
          error &&
          error.response &&
          error.response.data.Status === 4
        ) {
          dispatch({
            type: SIGN_UP_FAILURE,
            payload: {
              ...error.response,
              error: "ALREADY-EXISTS",
              isAuthenticated: false,
              isFetching: false,
              type: "Signup",
              isAccountVerified: false,
            },
          });
        } else {
          dispatch({
            type: LOG_IN_FAILURE,
            payload: {
              error: "Record does not exist",
              ...error.response,
              isAuthenticated: false,
              isFetching: false,
              type: "Signup",
              isAccountVerified: false,
            },
          });
        }
      });
  };
};

export const forgotPassword = (user) => {
  const mode = getAppMode();

  const requestBody = {
    EmailAddress: user.email,
    Source: mode,
  };
  return (dispatch) => {
    dispatch({
      type: FORGOT_PASSWORD_START,
      payload: {
        isAuthenticated: false,
        isFetching: true,
        type: "forgotpassword",
      },
    });
    const url = forgotPasswordURL();
    http
      .post(url, requestBody)
      .then((response) => {
        dispatch({
          type: FORGOT_PASSWORD_SUCCESS,
          payload: {
            isAuthenticated: false,
            isFetching: false,
            type: "forgotpassword",
          },
        });
      })
      .catch(() => {
        dispatch({
          type: FORGOT_PASSWORD_FAILURE,
          payload: {
            error: "",
            isAuthenticated: false,
            isFetching: false,
            type: "forgotpassword",
          },
        });
      });
  };
};

export const changePassword = (user, email) => {
  const requestBody = {
    OldPassword: user.oldPassword,
    EmailAddress: email,
    NewPassword: user.password,
  };
  return (dispatch) => {
    dispatch({
      type: CHANGE_PASSWORD_START,
      payload: {
        isAuthenticated: false,
        isFetching: true,
        isUserChangePassword: false,
        type: "changePassword",
        isButtonDisable: false,
      },
    });
    const url = changePasswordURL();
    http
      .post(url, requestBody)
      .then((response) => {
        dispatch({
          type: CHANGE_PASSWORD_SUCCESS,
          payload: {
            isAuthenticated: false,
            isFetching: false,
            isUserChangePassword: true,
            type: "changePassword",
            needPasswordChange: false,
            isButtonDisable: false,
          },
        });
      })
      .catch((error) => {
        if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.Status === 0
        ) {
          dispatch({
            type: CHANGE_PASSWORD_FAILURE,
            payload: {
              error: "Email Address or Old password is not matched.",
              isAuthenticated: false,
              isFetching: false,
              isUserChangePassword: false,
              type: "changePassword",
              needPasswordChange: false,
              isButtonDisable: false,
            },
          });
        } else if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.Status === 9
        ) {
          dispatch({
            type: CHANGE_PASSWORD_FAILURE,
            payload: {
              error:
                "This password is already used, please try a different one.",
              isAuthenticated: false,
              isFetching: false,
              isUserChangePassword: false,
              type: "changePassword",
              needPasswordChange: false,
              isButtonDisable: false,
            },
          });
        } else {
          dispatch({
            type: CHANGE_PASSWORD_FAILURE,
            payload: {
              error: "",
              isAuthenticated: false,
              isFetching: false,
              isUserChangePassword: false,
              type: "changePassword",
              needPasswordChange: false,
              isButtonDisable: false,
            },
          });
        }
      });
  };
};

export const getUserProfile = () => {
  return (dispatch) => {
    dispatch({
      type: USER_PROFILE_START,
      payload: {
        isAuthenticated: true,
        isFetching: true,
        hasSecurityQuestions: !!sessionStorage.getItem("hasSecurityQuestions"),
      },
    });
    const url = getUserProfileURL();
    http
      .get(url)
      .then((response) => {
        sessionStorage.setItem(
          "hasSecurityQuestions",
          response?.headers?.["x-security-questions"]?.trim()?.toLowerCase() ===
            "true"
        );

        dispatch({
          type: USER_PROFILE_SUCCESS,
          payload: {
            userProfile: response,
            isAuthenticated: true,
            isFetching: false,
            hasSecurityQuestions:
              response?.headers?.["x-security-questions"]
                ?.trim()
                ?.toLowerCase() === "true",
          },
        });
      })
      .catch(() => {
        dispatch({
          type: USER_PROFILE_FAILURE,
          payload: { error: "", isAuthenticated: false, isFetching: false },
        });
      });
  };
};

export const fetchUser = () => {
  /**  this is where you would make the fetch to the api endpoint ( feature of redux-thunk )
   * ex.
   * const reponse = await window.fetch('api/url/to/some/endpoint')
   * const data = await response.json()
   * dispatch({type: LOG_IN, payload: data})
   * for authentication the client is relying on
   * a state object authentication.isAuthenticated to be true for
   * for access to protected routes
   */
  return (dispatch) => {
    dispatch({
      type: FETCH_USER_PROFILE_START,
      isFetching: true,
      isLoading: true,
      isUserNotLoaded: false,
      fetchUserError: false,
      userProfileError: "",
    });
    const url = getFetchUser();

    http
      .get(url)
      .then((response) => {
        dispatch({
          type: FETCH_USER_PROFILE_SUCCESS,
          payload: {
            currentUser: response.data,
            isFetching: false,
            isLoading: false,
            isUserNotLoaded: true,
            fetchUserError: false,
            userProfileError: "",
           firstName : response?.data?.FirstName,
            lastName : response?.data?.LastName
          },
        });
      })
      .catch((error) => {
        dispatch({
          type: FETCH_USER_PROFILE_FAILURE,
          payload: {
            ...error,
            userProfileError:
              "Your request cannot be processed. Please reach out to Tech Support.",
            fetchUserError: true,
            currentUser: error?.response?.data || "Could not get user data",
            isFetching: false,
            isLoading: false,
            isUserNotLoaded: true,

          },
        });
      });
  };
};

export const resetPassword = (user) => {
  const mode = getAppMode();

  const requestBody = {
    ReferenceID: user.ReferenceID,
    Password: user.Password,
    ChallengeQuestions: user.ChallengeQuestions,
    Source: mode,
  };
  return (dispatch) => {
    dispatch({
      type: RESET_PASSWORD_START,
      payload: {
        isAuthenticated: false,
        isFetching: true,
        isUserChangePassword: false,
        type: "resetPassword",
      },
    });
    const url = resetPasswordURL();
    http
      .post(url, requestBody)
      .then((response) => {
        dispatch({
          type: RESET_PASSWORD_SUCCESS,
          payload: {
            isAuthenticated: false,
            isFetching: false,
            isUserChangePassword: true,
            type: "resetPassword",
          },
        });
      })
      .catch((error) => {
        if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.Status === 0
        ) {
          dispatch({
            type: RESET_PASSWORD_FAILURE,
            payload: {
              error: "Reference id does not exist",
              isAuthenticated: false,
              isFetching: false,
              isUserChangePassword: false,
              type: "resetPassword",
            },
          });
        } else if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.Status === 2
        ) {
          dispatch({
            type: RESET_PASSWORD_FAILURE,
            payload: {
              error: "Reference id is already used.",
              isAuthenticated: false,
              isFetching: false,
              isUserChangePassword: false,
              type: "resetPassword",
            },
          });
        } else if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.Status === 3
        ) {
          dispatch({
            type: RESET_PASSWORD_FAILURE,
            payload: {
              error: "Reference id is expired.",
              isAuthenticated: false,
              isFetching: false,
              isUserChangePassword: false,
              type: "resetPassword",
            },
          });
        } else if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.Status === 9
        ) {
          dispatch({
            type: RESET_PASSWORD_FAILURE,
            payload: {
              error:
                "This password is already used, please try a different one.",
              isAuthenticated: false,
              isFetching: false,
              isUserChangePassword: false,
              type: "resetPassword",
            },
          });
        } else {
          dispatch({
            type: RESET_PASSWORD_FAILURE,
            payload: {
              error:
                "Reset password failed, please check the details on the form.",
              isAuthenticated: false,
              isFetching: false,
              isUserChangePassword: false,
              type: "resetPassword",
            },
          });
        }
      });
  };
};

export const preResetPassword = (referenceId, isLoaderVisible) => {
  const mode = getAppMode();

  return (dispatch) => {
    dispatch({
      type: PRE_RESET_PASSWORD_START,
      payload: {
        isAuthenticated: false,
        isFetching: true,
        type: "preResetPassword",
        isResetPageLoading: isLoaderVisible ? true: false ,
      },
    });
    const url = getResetSecurityURL(referenceId, mode);
    http
      .get(url)
      .then((response) => {
        if (
          response?.status === 200 &&
          response?.headers?.["x-security-questions"]?.trim()?.toLowerCase() ===
            "true"
        ) {
          dispatch({
            type: PRE_RESET_PASSWORD_SUCCESS,
            payload: {
              isAuthenticated: false,
              isFetching: false,
              type: "preResetPassword",
              securityQuestions: response.data,
              hasResetSecurityQuestions:
                response?.headers?.["x-security-questions"]
                  ?.trim()
                  ?.toLowerCase() === "true",
              isResetPageLoading: true,
            },
          });
        } else {
          dispatch({
            type: PRE_RESET_PASSWORD_SUCCESS,
            payload: {
              isAuthenticated: false,
              isFetching: false,
              type: "preResetPassword",
              resetData: response.data,
              securityQuestions: [],
              hasResetSecurityQuestions:
                response?.headers?.["x-security-questions"]
                  ?.trim()
                  ?.toLowerCase() === "false",
              isResetPageLoading: true,
            },
          });
        }
      })
      .catch((error) => {
        if (
          error?.response?.headers?.["x-request-expired"]
            ?.trim()
            ?.toLowerCase() === "true"
        ) {
          dispatch({
            type: PRE_RESET_PASSWORD_FAILURE,
            payload: {
              error: "",
              isAuthenticated: false,
              isFetching: false,
              resetData: error?.response.data,
              expired: true,
              type: "preResetPassword",
              isResetPageLoading: true,
            },
          });
        } else {
          dispatch({
            type: PRE_RESET_PASSWORD_FAILURE,
            payload: {
              error: "",
              globalError: "Presetissue",
              isAuthenticated: false,
              isFetching: false,
              resetData: error?.response.data,
              type: "preResetPassword",
              isResetPageLoading: true,
            },
          });
        }
      });
  };
};

export const emulateUserLogIn = (user, authcode, clientKey) => {
  const querystring = require("querystring");
  const requestBody = {
    UserName: user.email,
    grant_type: "password",
    authcode: authcode,
    clientKey: clientKey,
  };
  return (dispatch) => {
    dispatch({
      type: EMULATE_USER_START,
      payload: {
        isAuthenticated: false,
        isFetching: true,
      },
    });
    const url = emulateUserLogInURL();
    http
      .post(url, querystring.stringify(requestBody))
      .then((response) => {
        const data = response.data;
        sessionStorage.setItem("access_token", data.access_token);
        sessionStorage.setItem(
          "hasSecurityQuestions",
          response?.headers?.["x-security-questions"]?.trim()?.toLowerCase() ===
            "true"
        );

        dispatch({
          type: EMULATE_USER_SUCCESS,
          payload: {
            isAuthenticated: true,
            hasSecurityQuestions: !!sessionStorage.getItem(
              "hasSecurityQuestions"
            ),

            isFetching: false,
          },
        });
        dispatch(getUserProfile());
      })
      .catch((error) => {
        if (error.response) {
          const rejectionReason =
            error?.response?.headers["x-rejection-reason"]; // Access the specific header
          const lockPeriod = error?.response?.headers["x-lock-period"]; // Access the specific header
          const accountUnverified =
            error?.response?.headers["x-account-unverified"]; // Access the specific header
          if (
            error?.response?.status === 400 &&
            rejectionReason?.trim()?.toLowerCase() === "accountlocked"
          ) {
            dispatch({
              type: EMULATE_USER_FAILURE,
              payload: {
                error: `This user’s account is locked and will be automatically unlocked within ${lockPeriod} hours.`,
                isAuthenticated: false,
                isFetching: false,
                isUserChangePassword: false,
              },
            });
          } else {
            if (accountUnverified?.trim()?.toLowerCase() === "true") {
              dispatch({
                type: EMULATE_USER_FAILURE,
                payload: {
                  error: "This account is unverified.",
                  isAuthenticated: false,
                  isFetching: false,
                  isUserChangePassword: false,
                },
              });
            } else {
              dispatch({
                type: EMULATE_USER_FAILURE,
                payload: {
                  error: "Record does not exist.",
                  isAuthenticated: false,
                  isFetching: false,
                  isUserChangePassword: false,
                },
              });
            }
          }
        } else {
          const accountUnverified =
            error?.response?.headers["x-account-unverified"]; // Access the specific header
          if (accountUnverified?.trim()?.toLowerCase() === "true") {
            dispatch({
              type: EMULATE_USER_FAILURE,
              payload: {
                error: "This account is unverified.",
                isAuthenticated: false,
                isFetching: false,
                isUserChangePassword: false,
              },
            });
          } else {
            // Handle errors where there is no response (e.g., network issues)
            dispatch({
              type: EMULATE_USER_FAILURE,
              payload: {
                error: "Record does not exist.",
                isAuthenticated: false,
                isFetching: false,
                isUserChangePassword: false,
              },
            });
          }
        }
      });
  };
};

export const emulateUserAuthorization = (authCode) => {
  const querystring = require("querystring");
  const requestBody = {
    grant_type: "password",
    authcode: authCode,
  };
  return (dispatch) => {
    dispatch({
      type: AUTHORIZED_EMULATE_USER_START,
      payload: {
        isEmulateAuthorized: false,
        isFetching: true,
        isLoading: false,
      },
    });
    const url = emulateUserAuthorizationURL();
    http
      .post(url, querystring.stringify(requestBody))
      .then((response) => {
        dispatch({
          type: AUTHORIZED_EMULATE_USER_SUCCESS,
          payload: {
            clientKey: response.data.clientKey,
            isEmulateAuthorized: true,
            isFetching: false,
            isLoading: true,
          },
        });
      })
      .catch(() => {
        dispatch({
          type: AUTHORIZED_EMULATE_USER_FAILURE,
          payload: {
            error: "You are not authorized to access this page",
            isEmulateAuthorized: false,
            isFetching: false,
            isLoading: true,
          },
        });
      });
  };
};

export const getSecurityQuestions = () => {
  return (dispatch) => {
    dispatch({
      type: FETCH_ALL_SECURITY_QUESTIONS_START,
      isFetching: true,
      isLoading: false,
      isSecurityQuestionsFailed: false,
      isSecurityQuestionNotLoaded: false,
    });
    const url = getSecurityQuestionsURL();
    http
      .get(url)
      .then((response) => {
        dispatch({
          type: FETCH_ALL_SECURITY_QUESTIONS_SUCCESS,
          payload: {
            securityQuestions: response.data,
            isFetching: false,
            isLoading: false,
            isSecurityQuestionNotLoaded: true,
            isSecurityQuestionsFailed: false,
          },
        });
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ALL_SECURITY_QUESTIONS_FAILURE,
          payload: {
            error: ERRORS_CONST.ERROR_FETCHING_SECURITY_QUESTIONS,
            ...error,
            securityQuestions: "Could not get any security questions",
            isFetching: false,
            isLoading: true,
            isSecurityQuestionsFailed: true,
            isSecurityQuestionNotLoaded: true,
          },
        });
      });
  };
};

export const clearUpdateProfile = () => {
  return (dispatch) => {
    dispatch({
      type: CLEAR_UPDATE_USER_PROFILE_FAILURE,
      payload: {
        data: null,
        isFetching: false,
        error: "",
        updateProfileSuccess: false,
      },
    });
  };
};

export const clearLoginFailure = () => {
  return (dispatch) => {
    dispatch({
      type: CLEAR_UPDATE_LOGIN_FAILURE_FAILURE,
      payload: {
        data: null,
        isFetching: false,
        error: "",
        userUnverified: false,
      },
    });
  };
};

export const updateProfile = (payload) => {
  return (dispatch) => {
    dispatch({
      type: UPDATE_USER_PROFILE_START,
      payload: {
        isFetching: true,
        updateProfileSuccess: false,
        userProfileError: "",
      },
    });
    const url = updateUserProfile();
    http
      .post(url, payload)
      .then((response) => {
        dispatch({
          type: UPDATE_USER_PROFILE_SUCCESS,
          payload: {
            data: response.data,
            isFetching: false,
            userProfileError: "",
            updateProfileSuccess: true,
          },
        });
        dispatch(fetchUser());
      })
      .catch((error) => {
        dispatch({
          type: UPDATE_USER_PROFILE_FAILURE,
          payload: {
            userProfileError: "Failed to update personal details.",
            isFetching: false,
            updateProfileSuccess: false,
          },
        });
      });
  };
};

export const verifyAccount = (referenceId) => {
  const mode = getAppMode()
  const payload = {
    "ReferenceID": referenceId,
    "Source": mode
}
  return (dispatch) => {
    dispatch({
      type: VERIFY_ACCOUNT_START,
      payload: {
        isVerifyAccountFetching: true,
        isVerified: false,
        userVerificationExpired: false,
      },
    });
    const url = setVerifyAccount();
    http
      .put(url, payload)
      .then((response) => {
        dispatch({
          type: VERIFY_ACCOUNT_SUCCESS,
          payload: {
            isVerifyAccountFetching: false,
            isVerified: true,
            data: response.data,
            userVerificationExpired: false,
          },
        });
      })
      .catch((error) => {
        if (
          error?.response?.headers["x-request-expired"] ||
          error?.response?.headers["x-request-used"]
        ) {
          dispatch({
            type: VERIFY_ACCOUNT_FAILURE,
            payload: {
              isVerifyAccountFetching: false,
              isVerified: false,
              userVerificationExpired:
                error?.response?.headers["x-request-expired"]
                  ?.trim()
                  ?.toLowerCase() === "true" ||
                error?.response?.headers["x-request-used"]
                  ?.trim()
                  ?.toLowerCase() === "true",
              error: error.message || "Verification failed",
            },
          });
        } else {
          dispatch({
            type: VERIFY_ACCOUNT_FAILURE,
            payload: {
              isVerifyAccountFetching: false,
              isVerified: false,
              userVerificationError: true,
              error: error.message || "Verification failed",
            },
          });
        }
      });
  };
};
